/**
 * Roles that were approved and then dropped.
 *
 * Theresa asked for them "greyed but collapsed": a cancelled seat is part of
 * what happened to the trimester, and hiding it entirely makes a plan that was
 * cut look like a plan that was never made. Collapsed because it is history, not
 * work.
 *
 * They are counted in NOTHING. They never enter the tree's `roles` arrays, which
 * is what every demand and FTE figure is summed from — see buildTree.
 */
import { useState } from 'react';
import type { BoardRole } from '../../../types/taDemand';
import { NameCells, CELL } from './demandGrid';

export function CancelledRoles({ roles, depth }: { roles: BoardRole[]; depth: number }) {
  const [open, setOpen] = useState(false);
  if (!roles.length) return null;
  return (
    <>
      <div className="grid border-t border-gray-100" style={{ gridTemplateColumns: 'var(--demand-tmpl)' }}>
        <NameCells
          depth={depth}
          bg="bg-white"
          who={
            <button
              type="button"
              onClick={() => setOpen((v) => !v)}
              className="min-w-0 truncate text-left text-[12px] text-gray-400 hover:text-gray-600"
            >
              {open ? '▾' : '▸'} {roles.length} cancelled{' '}
              {roles.length === 1 ? 'role' : 'roles'}
            </button>
          }
        >
          <div className={CELL} />
          <div className={CELL} />
          <div className={CELL} />
          <div className={CELL} />
        </NameCells>
      </div>
      {open &&
        roles.map((r) => (
          <div
            key={r.id}
            className="grid border-t border-gray-100"
            style={{ gridTemplateColumns: 'var(--demand-tmpl)' }}
          >
            <NameCells
              depth={depth + 1}
              bg="bg-white"
              who={
                <span className="min-w-0 truncate text-[13px] text-gray-400 line-through" title={r.title}>
                  {r.title}
                </span>
              }
            >
              <div className={CELL}>
                <span className="text-[12px] text-gray-400">{r.level}</span>
              </div>
              <div className={CELL} />
              <div className={CELL}>
                <span className="min-w-0 truncate text-[11px] text-gray-400">
                  {r.month ? `planned ${r.month}` : ''}
                </span>
              </div>
              <div className={CELL}>
                <span className="shrink-0 rounded-sm bg-gray-100 px-1.5 text-[11px] font-medium leading-4 text-gray-500">
                  cancelled
                </span>
              </div>
            </NameCells>
          </div>
        ))}
    </>
  );
}
